import React from 'react';
import TrackVisibility from "react-on-screen";
import Skill from "./Skill";

const progressData = [
    {
      id: 1,
      title: "Score",
      percantage: 40,
      progressColor: "#f3c623",
    },
];

const ScoreProgress = () => {
    return (
        <>
            {progressData.map((progress) => (
            <TrackVisibility
                once
                key={progress.id}
                className="single-progress"
            >
                <Skill progress={progress} />
            </TrackVisibility>
            ))} 
        </>
    )
}


export default ScoreProgress;
